export default "__VITE_ASSET__1a2c2b39__"